<div class="checkbox flex medium-type">
  <label class="fill flex flex-1 flex--nogrow ps-medium-r" [for]="cid" [ngClass]="{ 'link-hover': !disabled }">
    <input
      class="is-vishidden"
      type="checkbox"
      [checked]="checked"
      [attr.tabIndex]="tabIndex"
      [attr.name]="name"
      [attr.value]="value"
      [attr.id]="cid"
      [attr.disabled]="disabled ? 'disabled' : undefined"
      (change)="interactionEvent($event)"
      (click)="clickEvent($event)"
      (blur)="blurEvent()"
      (focus)="focusEvent()"
    />
    <span
      aria-hidden="true"
      class="icons ms-xsmall-r nordic-blue-900-text inline-block flex--self-start"
      [ngClass]="theme"
    >
      <fcom-icon
        *ngIf="!checked"
        [name]="theme === CheckBoxTheme.SQUARE ? 'checkbox-unselected' : 'checkmark-button-unselected'"
        class="is-xsmall"
      ></fcom-icon>
      <fcom-icon
        *ngIf="checked"
        [name]="theme === CheckBoxTheme.SQUARE ? 'checkbox-selected' : 'checkmark-button-selected'"
        class="is-xsmall"
      ></fcom-icon>
    </span>
    <span class="text">
      <ng-content></ng-content>
    </span>
  </label>
</div>
